import { getApiActionTypes } from '../storeHelpers';

export const fetchGenericScreenTypes = getApiActionTypes('FETCH_GENERIC_SCREEN');
export const fetchGenericScreenHeaderTypes = getApiActionTypes('FETCH_GENERIC_SCREEN_HEADER');
export const updateGenericScreenTypes = getApiActionTypes('UPDATE_GENERIC_SCREEN');
